{
  "components": {
    "summary": {
      "summaryDay": {
        "noContent": "Nessun contenuto '{contentType}' trovato in questo giorno..."
      }
    }
  },
  "contentNode": {
    "columnLayout": {
      "entity": {
        "column": {
          "name": "Colonna|Colonna {name}"
        }
      },
      "name": "Layout delle colonne"
    },
    "laThematicArea": {
      "entity": {
        "option": {
          "campsiteAndSurroundings": {
            "description": "Allestire campo/dintorni, smontare le costruzioni, preparare le installazioni per il terreno da gioco e le attrezzature sportive.",
            "name": "Campo/dintorni"
          },
          "natureAndEnvironment": {
            "description": "Flora e fauna, tutela dell’ambiente al campo, meteorologia e astronomia, tecniche di trasmissione, accensione di un fuoco.",
            "name": "Natura e ambiente"
          },
          "outdoorTechnique": {
            "description": "Pianificazione delle escursioni, lettura delle carte topografiche (p. es. NORDA), schizzi topografici, strumenti di supporto (p.es. bussola, GPS, altimetro, ecc.), orientamento sul terreno.",
            "name": "Tecniche outdoor"
          },
          "pioneeringTechnique": {
            "description": "Installare il bivacco, costruire un igloo, tecniche relative a materiali ed equipaggiamento, effettuare la manutenzione del materiale, montare e smontare le costruzioni pionieristiche, tecniche delle corde e dei nodi, tirolese, ponti di corda, discesa in corda doppia.",
            "name": "Tecnica pionieristica"
          },
          "preventionAndIntegration": {
            "description": "Attività volte a promuovere la prevenzione e l’integrazione nonché a migliorare le competenze dei partecipanti in questo ambito.",
            "name": "Prevenzione e integrazione"
          },
          "security": {
            "description": "Sicurezza durante le attività al campo, organizzazione in caso di infortuni e sistema di allerta, primi soccorsi, riflessioni sulla sicurezza.",
            "name": "Sicurezza"
          }
        }
      },
      "info": "Un'attività del campo Y+S deve trattare almeno uno degli argomenti elencati.{br}Seleziona gli argomenti da trattare in questo blocco.",
      "name": "Area tematica AC"
    },
    "material": {
      "info": "Qui puoi inserire i requisiti del materiale per questo blocco.{br}Puoi gestire gli elenchi dei materiali nel menu 'Amministrazione'.{br}Puoi trovare un riepilogo degli acquisti nel menu 'Materiale'.",
      "name": "Materiale"
    },
    "notes": {
      "info": "Qui puoi inserire qualsiasi nota, ad esempio idee, impegni, domande aperte, contatti, collegamenti con i mezzi pubblici, ecc.",
      "name": "Noti"
    },
    "responsiveLayout": {
      "mainContent": "Contenuto principale",
      "name": "Layout di default",
      "printAboveMainContent": "Stampa sopra il contenuto principale",
      "printBelowMainContent": "Stampa sotto il contenuto principale"
    },
    "safetyConsiderations": {
      "info": "Alcuni blocchi richiedono una riflessione sui rischi. Qui puoi registrare questi pensieri.{br}Registra i rischi che hai identificato e come puoi affrontarli.",
      "name": "Considerazioni sulla sicurezza"
    },
    "storyboard": {
      "entity": {
        "section": {
          "fields": {
            "column1": "Tempo",
            "column2Html": "Programma",
            "column3": "Responsabile"
          },
          "name": "Sezione del programma | Sezioni del programma"
        }
      },
      "info": "Qui puoi pianificare il contenuto di questo blocco.{br}Nella colonna di sinistra [Tempo] puoi registrare la durata dei singoli elementi.{br}Nella colonna di destra [Responsabile] puoi assegnare delle persone.",
      "name": "Programma"
    },
    "storycontext": {
      "info": "Descrivi come questo blocco si inserisce nella storia del campo.{br}Puoi trovare un riepilogo di tutti gli elementi della storia nel menu \"Storia\".{br}Puoi anche elaborare prima una storia continua nel menu \"Storia\", in modo da incorporare perfettamente il contenuto del blocco nella storia.",
      "name": "Storia"
    }
  },
  "entity": {
    "activity": {
      "fields": {
        "category": "Categoria di attività",
        "location": "Posto",
        "progressLabel": "Stato",
        "responsible": "Responsabile",
        "title": "Titolo"
      },
      "name": "Attività",
      "new": "Nuova attività"
    },
    "activityProgressLabel": {
      "fields": {
        "title": "Titolo"
      }
    },
    "camp": {
      "collaborators": {
        "contributor": "Aiutante",
        "guest": "Ospite",
        "invite": "Invita",
        "manager": "Amministrazione",
        "member": "Membro"
      },
      "fields": {
        "addressCity": "Città",
        "addressName": "Nome",
        "addressStreet": "Via",
        "addressZipcode": "Codice postale",
        "motto": "Motto / Tema",
        "shortTitle": "Titolo breve",
        "title": "Titolo"
      },
      "name": "Campo",
      "prototype": "Modello di campo"
    },
    "campCollaboration": {
      "fields": {
        "abbreviation": "Abbreviazione",
        "color": "Colore",
        "inviteEmail": "E-mail",
        "role": "Ruolo",
        "status": "Stato"
      },
      "status": {
        "inactive": "non attivo"
      }
    },
    "category": {
      "fields": {
        "color": "Colore",
        "name": "Nome",
        "numberingStyle": "Stile della numerazione",
        "short": "Abbreviazione"
      },
      "name": "Categorie di attività",
      "numberingStyles": {
        "1": "1, 2, 3 - numeri",
        "A": "A, B, C - maiuscole di blocco",
        "I": "I, II, III - numeri romani maiuscoli",
        "a": "a, b, c - lettere minuscole",
        "i": "i, ii, iii - numeri romani minuscoli"
      }
    },
    "contentType": {
      "name": "Tipo di contenuto | Tipi di contenuto"
    },
    "day": {
      "fields": {
        "dayResponsibles": "Responsabile del giorno"
      },
      "name": "Giorno | Giorni"
    },
    "materialItem": {
      "fields": {
        "article": "Articolo",
        "list": "Elenco dei materiali",
        "quantity": "Quantità",
        "reference": "Attività / Periodo",
        "unit": "Unità"
      }
    },
    "materialList": {
      "fields": {
        "name": "Nome"
      },
      "name": "Elenco dei materiali"
    },
    "period": {
      "defaultDescription": "Campo principale",
      "fields": {
        "description": "Descrizione",
        "end": "Fine",
        "start": "Inizio"
      },
      "name": "Periodo | Periodi"
    },
    "profile": {
      "fields": {
        "abbreviation": "Abbreviazione",
        "color": "Colore",
        "email": "Indirizzo email",
        "firstname": "Nome",
        "language": "Lingua",
        "nickname": "Soprannome",
        "password": "Parola d'ordine",
        "surname": "Cognome"
      },
      "name": "Profilo"
    },
    "scheduleEntry": {
      "fields": {
        "duration": "Durata",
        "endDate": "Data di fine",
        "endDatetime": "Ora di fine",
        "nr": "N.",
        "startDate": "Data di inizio",
        "startDatetime": "Ora di inizio",
        "time": "Tempo"
      },
      "name": "Inserimento nel programma"
    }
  },
  "global": {
    "datetime": {
      "dateLong": "dd L",
      "dateShort": "dd D.M.",
      "dateTimeLong": "dd L LT",
      "duration": {
        "hoursAndMinutes": "{hours}h {minutes}min",
        "hoursOnly": "{hours}h",
        "minutesOnly": "{minutes}min"
      },
      "hourLong": "LT",
      "hourShort": "H:mm"
    }
  },
  "print": {
    "activity": {
      "title": "Attività"
    },
    "config": {
      "periods": "Sezione/i portante/i"
    },
    "cover": {
      "title": "Pagina di copertina"
    },
    "picasso": {
      "title": "Panoramica del programma {period}"
    },
    "program": {
      "title": "Programma"
    },
    "safetyConsiderations": {
      "title": "Considerazioni sulla sicurezza"
    },
    "story": {
      "title": "Storia"
    },
    "toc": {
      "title": "Indice dei contenuti"
    }
  }
}
